export const SET_OPTIONS = 'set options';
export const SET_APP_OPTIONS = 'set app options';

/* istanbul ignore next */
export function setOptions(options){
    return  {
        type : SET_OPTIONS,
        options : options
    };
}

/* istanbul ignore next */
export function setAppOptions(options){
    return  {
        type : SET_APP_OPTIONS,
        options : options
    };
}



// WEBPACK FOOTER //
// ./src/actions/options.action.js